// src/redux/defectTypesSlice.ts
// 不良理由区分
import { createSlice} from '@reduxjs/toolkit';

import { AnyAction, Dispatch } from "redux";
import { appendAlert } from "../redux/alertSlice"
import apiAxios from '../utils/apiAxios';

// API GET /defect_typesのデータ型
type DefectType = {
  ja: string,
  en?: string,
  vi?: string,
  zh?: string, 
  id?: string 
};
type DefectGroup = {
  ja: string,
  en?: string,
  vi?: string,
  zh?: string, 
  id?: string 
};

export type Defect = {
  defect_type_id: number,
  defect_type: DefectType,
  defect_group_id: number,
  defect_group: DefectGroup
};

type DefectTypes = {
  defectsTypes:Defect[],
};

// 初期値
const initialState:DefectTypes = {
  defectsTypes : [],
}

export const defectTypesSlice = createSlice({
  name: 'defectTypesSlice',
  initialState, 
  reducers: {
    setDefectTypes: (state, {payload}) => {
      state.defectsTypes = payload;
    },
  },
});

const {setDefectTypes} = defectTypesSlice.actions;

// 不良理由区分一覧取得
const fetchDefectTypes = () => {
  return async (dispatch:Dispatch<AnyAction>) => {
    try {
      const response = await apiAxios.get(`/defect_types`);
      const data = response.data;
      dispatch(setDefectTypes(data));
    } catch (error:any) {
      console.error(error);
      dispatch(appendAlert({
        severity:"error",
        message:"データの取得に失敗しました。" + error.message,
        displayTime: 5000
      },));
    }
  }
}

export {fetchDefectTypes, setDefectTypes}
export default defectTypesSlice.reducer;
